import {
  V2ListRateTablesForAccountApiArg,
  useV2ListRateTablesForAccountQuery,
} from "@generated";
import type { RateTable } from "../types";

export interface UseRateTablesListArgs {
  page?: V2ListRateTablesForAccountApiArg["page"];
  filter?: V2ListRateTablesForAccountApiArg["filter"];
}

export interface RateTablesListPageMeta {
  recordCount: number;
  pageCount: number;
}

export const useRateTablesList = ({ page, filter }: UseRateTablesListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListRateTablesForAccountQuery(
      { page, filter, include: ["currency"] },
      { refetchOnMountOrArgChange: true }
    );

  const included = (data as any)?.included ?? [];
  const currencyNameFor = (id?: string | number): string =>
    included.find(
      (i: any) => i.type === "currencies" && String(i.id) === String(id)
    )?.attributes?.name ?? "";

  const rows: RateTable[] = (data?.data ?? []).map((rt: any) => {
    const attrs = rt.attributes ?? {};
    const currencyId = rt.relationships?.currency?.data?.id;
    return {
      id: String(rt.id),
      name: attrs.name ?? "",
      currencyId: currencyId != null ? String(currencyId) : null,
      currencyName: currencyNameFor(currencyId),
      accountingCode: attrs["accounting-code"] ?? "",
      default: !!attrs.default,
    };
  });

  const pageMeta: RateTablesListPageMeta = {
    recordCount: (data as any)?.meta?.["record-count"] ?? 0,
    pageCount: (data as any)?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};

export default useRateTablesList;
